import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "modal-dialog" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_6 = { class: "row-top d-flex" }
const _hoisted_7 = {
  key: 0,
  class: "popup-title"
}
const _hoisted_8 = {
  key: 1,
  class: "event-info event-info-list list-unstyled"
}
const _hoisted_9 = {
  key: 0,
  class: "event-info-item"
}
const _hoisted_10 = ["alt"]
const _hoisted_11 = {
  key: 1,
  class: "event-info-item"
}
const _hoisted_12 = ["alt"]
const _hoisted_13 = {
  key: 2,
  class: "flex-grow-1"
}
const _hoisted_14 = { class: "event-info-item dropdown relative" }
const _hoisted_15 = ["alt"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 0,
  class: "share-dropdown shadow-lg bg-white peer-checked:flex flex-col w-full mt-1"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "arrow-up" }, null, -1)
const _hoisted_19 = ["href", "title"]
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = ["virtualIndex"]
const _hoisted_22 = { class: "block-img" }
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = ["autoplay"]
const _hoisted_25 = ["src"]
const _hoisted_26 = { key: 2 }
const _hoisted_27 = ["src"]
const _hoisted_28 = ["autoplay"]
const _hoisted_29 = ["src"]
const _hoisted_30 = { key: 3 }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = ["virtualIndex"]
const _hoisted_34 = { class: "block-img" }
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = ["autoplay"]
const _hoisted_37 = ["src"]
const _hoisted_38 = { key: 2 }
const _hoisted_39 = ["src"]
const _hoisted_40 = ["autoplay"]
const _hoisted_41 = ["src"]
const _hoisted_42 = { class: "row-bottom d-flex" }
const _hoisted_43 = { class: "column" }
const _hoisted_44 = {
  key: 0,
  class: "event-info event-info-list list-unstyled"
}
const _hoisted_45 = { class: "event-info-item" }
const _hoisted_46 = ["src", "alt"]
const _hoisted_47 = { key: 0 }
const _hoisted_48 = {
  key: 1,
  class: "text"
}
const _hoisted_49 = {
  key: 0,
  class: "column"
}
const _hoisted_50 = { class: "list-tag list list-unstyled" }
const _hoisted_51 = ["onClick"]

import { ref, computed, onMounted, onUpdated } from "vue";
import { useFilterPageStore } from "@/stores/filterPageStore";
import { StoryDto } from "@/models/FilterPageTypes";
import { MEDIA_TYPE, ShareLink } from "@/models/AdditionalDataTypes";
import { STORY_TYPE } from "@/models/StoryTypeEnum";
import { register } from "swiper/element/bundle";
import { WINDOW_WIDTH } from "@/models/WidthTypeEnum";
import { Swiper } from "swiper/types";
import { useRouter } from "vue-router";

interface SwiperInstance extends HTMLElement {
  swiper?: Swiper;
}

// https://swiperjs.com/element

export default /*#__PURE__*/_defineComponent({
  __name: 'StoryDetailsModal',
  props: {
    selectedStory: null,
    shareLinks: null,
    pageTitle: null
  },
  setup(__props: any) {

const props = __props as { 
  selectedStory: StoryDto | undefined,
  shareLinks: ShareLink[],
  pageTitle: string | undefined
};

register(true);
const router = useRouter();



const show = ref(false);

//const absoluteUrl = ref<string>("");
const dir = computed(() => document.dir);
const swiperKey = ref<Boolean>(false);
const modalInstance = ref<HTMLElement>();

const rtlSwiperStyles = `.swiper-pagination-fraction {
            direction: ltr;
            background: rgba(0,0,0,0.5);
            border-radius: 25px;
            width: 60px;
            color: #fff;
            position: absolute;
            bottom: 70px;
            margin-left: 20px;
            display: none;

            @media (min-width: 1200px) {
                margin-left: 20px;
            }

        }

        .swiper-slide {
            overflow: hidden;
            padding-bottom: 60px;
        }
    
        .swiper-button-prev,
        .swiper-button-next {
            width: 40px;
            height: 40px;
            background: #F4F4F4;
            border: none;
            border-radius: 50%;
            position: absolute;
            bottom: 0;
            top: unset;
            font-size: 0;
            line-height: 0;
            left: 60px !important;
            right: unset !important;

            @media (min-width: 992px) {
              top: 0;
              bottom: unset;
              margin-top: 0;
            }

            &::after {
                content: '' !important;
                display: block;
                background: url('../../images/ico-arrow.svg') no-repeat;
                width: 23px;
                height: 22px;
            }
        }

        .swiper-button-next {
            left: 0 !important;
            &::after {
                transform: rotate(180deg);
            }
        }
    }
 `;

const ltrSwiperStyles = `.swiper-pagination-fraction {
        direction: ltr;
        background: rgba(0,0,0,0.5);
        border-radius: 25px;
        width: 60px;
        color: #fff;
        position: absolute;
        bottom: 70px;
        margin-left: 20px;
        display: none;
        top: unset;

        @media (min-width: 1200px) {
            margin-left: 20px;
            position: absolute;
            left: 50%;
            transform: translateX(-60%);
            bottom: 0;
        }

    }

    .swiper-slide {
        overflow: hidden;
        padding-bottom: 60px;
    }
    
    .swiper-button-prev,
    .swiper-button-next {
        width: 40px;
        height: 40px;
        background: #F4F4F4;
        border: none;
        border-radius: 50%;
        position: absolute;
        bottom: 0;
        top: unset;
        font-size: 0;
        line-height: 0;
        right: 0 !important;
        left: unset !important;

        @media (min-width: 992px) {
          top: 0;
          bottom: unset;
          margin-top: 0;
        }

        &::after {
            content: '' !important;
            display: block;
            background: url('../../images/ico-arrow.svg') no-repeat;
            width: 23px;
            height: 22px;
        }
    }

    .swiper-button-prev {
        right: 60px !important;

        &::after {
            transform: rotate(180deg);
        }
    }

    .swiper-button-next {

        &::after {
            transform: rotate(360deg);
        }
    }
}
`;

const swiperStyles = [dir.value === "rtl" ? rtlSwiperStyles : ltrSwiperStyles];

const filterPageStore = useFilterPageStore();

const altCalendar = computed(() =>
  filterPageStore.getLocalization("Accessability.Images.Calendar")
);
const altLocation = computed(() =>
  filterPageStore.getLocalization("Accessability.Images.Location")
);
const altShare = computed(() =>
  filterPageStore.getLocalization('Accessability.Images.Share')
);
const modalClose = computed(() =>
  filterPageStore.getLocalization("Accessability.Modal.Close")
);

const isDeskAutoplay = computed(() => window.innerWidth > WINDOW_WIDTH.lg);

// The story's own page, not window.location: the collection URL carries the filter query, and its "&"s
// split the share target's own query string, so the shared link fell back to the collection (TACM-1701).
const shareUrl = computed(() => {
  const detailsUrl = props.selectedStory?.DetailsUrl;
  return detailsUrl && detailsUrl !== "#"
    ? new URL(detailsUrl, window.location.origin).href
    : window.location.href;
});

const clickShareMobile = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          url: shareUrl.value
        });
      } catch (err) {
        console.error('Error sharing link:', err);
      }
    } else {
      alert(filterPageStore.getLocalization('FilterPage.ShareNotSupported'));
    }
}

function onTagsItemClick(e: Event, tag) {
  const elem = e?.target as HTMLElement;
  elem?.classList?.add("active");
  filterPageStore.searchStoryByTag(tag);
  document.getElementById("modal-closing-button")?.click();
  window.scrollTo(0, 0);
}

function pauseVideoAndAudioElements(parentSelector: string) {
  console.log("pause event");
  document
    .querySelectorAll(`${parentSelector} video, ${parentSelector} audio`)
    .forEach((el) => {
      if (el instanceof HTMLVideoElement || el instanceof HTMLAudioElement) {
        el.pause();
      }
    });
}

function formattedShareLink(shareLink: string) {
  return shareLink
    .replace("#Url#", encodeURIComponent(shareUrl.value))
    .replace("#Title#", props.pageTitle ?? "")
    .replace("#Name#", props.pageTitle ?? "");
}

onUpdated(() => {
  if (props.selectedStory) {
    const swiperElement = document.querySelector<SwiperInstance>("swiper-container")
      ?.swiper;
    swiperElement?.on("slideChange", () => {
      pauseVideoAndAudioElements("#storyModal-1");
    });
    // @ts-ignore
    $("#storyModal-1").modal("show");
  }
});

onMounted(async () => {
  modalInstance.value?.addEventListener("hide.bs.modal", () => {
    show.value = false
    pauseVideoAndAudioElements("#storyModal-1");
  });
  modalInstance.value?.addEventListener("hidden.bs.modal", () => {
    const fullPath = router.currentRoute.value.fullPath;
    window.history.replaceState({}, "", fullPath);
  });
  modalInstance.value?.addEventListener("show.bs.modal", () => {
    swiperKey.value = !swiperKey.value;
    const content = document.querySelector(".swiper-slide-active")?.children[0]
      ?.children[0];
    if (content && content instanceof HTMLVideoElement)
      (content as HTMLVideoElement)?.play();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "modalInstance",
    ref: modalInstance,
    class: "modal fade",
    id: "storyModal-1",
    tabindex: "-1",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true",
    "data-bs-backdrop": "true"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": _unref(modalClose),
            id: "modal-closing-button"
          }, null, 8, _hoisted_4)
        ]),
        (__props.selectedStory)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass(
                __props.selectedStory.PreviewType === _unref(STORY_TYPE).Text ? 'column-lg-12' : 'column'
              )
                }, [
                  (__props.selectedStory.Title)
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(__props.selectedStory.Title), 1))
                    : _createCommentVNode("", true),
                  (__props.selectedStory.Location || __props.selectedStory.FormattedDate)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                        (__props.selectedStory.Location)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                              _createElementVNode("img", {
                                class: "img-fluid",
                                src: "/images/ico-location.svg",
                                alt: _unref(altLocation)
                              }, null, 8, _hoisted_10),
                              _createElementVNode("p", null, _toDisplayString(__props.selectedStory.Location), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (__props.selectedStory.FormattedDate)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                              _createElementVNode("img", {
                                class: "img-fluid",
                                src: "/images/ico-calendar.svg",
                                alt: _unref(altCalendar)
                              }, null, 8, _hoisted_12),
                              _createElementVNode("p", null, _toDisplayString(__props.selectedStory.FormattedDate), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (!_unref(isDeskAutoplay))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_13))
                          : _createCommentVNode("", true),
                        _createElementVNode("li", _hoisted_14, [
                          _createElementVNode("div", {
                            class: "cursor-pointer h-10 flex items-center share-btn",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(isDeskAutoplay) ? show.value = !show.value : clickShareMobile()))
                          }, [
                            _createElementVNode("img", {
                              class: "img-fluid",
                              src: "/images/ico-share.svg",
                              alt: _unref(altShare)
                            }, null, 8, _hoisted_15),
                            (_unref(isDeskAutoplay))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_unref(altShare)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (show.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _hoisted_18,
                                _createElementVNode("div", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.shareLinks, (link, index) => {
                                    return (_openBlock(), _createElementBlock("a", {
                                      key: index,
                                      href: formattedShareLink(link.Link),
                                      class: "share-dropdown-item block p-2 border-transparent border-l-4",
                                      title: link.LinkName,
                                      "aria-label": "linkName",
                                      target: "_blank"
                                    }, [
                                      _createTextVNode("> "),
                                      _createElementVNode("img", {
                                        src: link.Icon,
                                        alt: link.LinkName
                                      }, null, 8, _hoisted_20),
                                      _createElementVNode("p", null, _toDisplayString(link.LinkName), 1)
                                    ], 8, _hoisted_19))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
                  __props.selectedStory.SliderImagesMobile?.length != 0 &&
                  __props.selectedStory.PreviewType !== _unref(STORY_TYPE).Text
                )
                    ? (_openBlock(), _createElementBlock("swiper-container", {
                        key: swiperKey.value,
                        "space-between": "30",
                        "slides-per-view": "1",
                        loop: "true",
                        navigation: "true",
                        pagination: { type: 'fraction' },
                        injectStyles: swiperStyles,
                        virtual: "true",
                        class: "column images-slider d-lg-none w-100 mb-4"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectedStory.SliderImagesMobile, (imag, index) => {
                          return (_openBlock(), _createElementBlock("swiper-slide", {
                            class: "list-item my-auto swiper-slide",
                            key: `slide-${index}-${__props.selectedStory.KeyId}`,
                            virtualIndex: `slide-${index}-${__props.selectedStory.KeyId}`
                          }, [
                            _createElementVNode("div", _hoisted_22, [
                              (imag.Type === _unref(MEDIA_TYPE).Image)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: imag.Url,
                                    alt: imag.Alt,
                                    class: "img-fluid"
                                  }, null, 8, _hoisted_23))
                                : _createCommentVNode("", true),
                              (imag.Type === _unref(MEDIA_TYPE).Video)
                                ? (_openBlock(), _createElementBlock("video", {
                                    key: 1,
                                    controls: "true",
                                    autoplay: !_unref(isDeskAutoplay)
                                  }, [
                                    _createElementVNode("source", {
                                      src: imag.Url,
                                      type: "video/mp4"
                                    }, null, 8, _hoisted_25)
                                  ], 8, _hoisted_24))
                                : _createCommentVNode("", true),
                              (imag.Type === _unref(MEDIA_TYPE).Audio)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                    _createElementVNode("img", {
                                      class: "img-fluid",
                                      style: {"width":"100%"},
                                      src: 
                          __props.selectedStory.MobilePreview?.Url
                            ? __props.selectedStory.MobilePreview.Url
                            : ''
                        
                                    }, null, 8, _hoisted_27),
                                    (imag?.Url)
                                      ? (_openBlock(), _createElementBlock("audio", {
                                          key: 0,
                                          class: "audio-container",
                                          controls: "true",
                                          autoplay: !_unref(isDeskAutoplay),
                                          style: {"width":"100%"}
                                        }, [
                                          _createElementVNode("source", {
                                            src: imag.Url,
                                            type: "audio/mp3"
                                          }, null, 8, _hoisted_29)
                                        ], 8, _hoisted_28))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ], 8, _hoisted_21))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (__props.selectedStory.InnerDescription)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        (__props.selectedStory.PreviewType === _unref(STORY_TYPE).Text)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "text-type-text",
                              innerHTML: __props.selectedStory.InnerDescription
                            }, null, 8, _hoisted_31))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "text",
                              innerHTML: __props.selectedStory.InnerDescription
                            }, null, 8, _hoisted_32))
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                (
                __props.selectedStory.SliderImages?.length != 0 &&
                __props.selectedStory.PreviewType !== _unref(STORY_TYPE).Text
              )
                  ? (_openBlock(), _createElementBlock("swiper-container", {
                      key: swiperKey.value,
                      "space-between": "30",
                      "slides-per-view": "1",
                      loop: "true",
                      navigation: "true",
                      pagination: { type: 'fraction' },
                      injectStyles: swiperStyles,
                      virtual: "true",
                      class: "column images-slider d-none d-lg-block disable-context-menu"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectedStory.SliderImages, (imag, index) => {
                        return (_openBlock(), _createElementBlock("swiper-slide", {
                          class: "list-item swiper-slide",
                          key: `slide-${index}-${__props.selectedStory.KeyId}`,
                          virtualIndex: `slide-${index}-${__props.selectedStory.KeyId}`
                        }, [
                          _createElementVNode("div", _hoisted_34, [
                            (imag.Type === _unref(MEDIA_TYPE).Image)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: imag.Url,
                                  alt: imag.Alt,
                                  class: "img-fluid"
                                }, null, 8, _hoisted_35))
                              : _createCommentVNode("", true),
                            (imag.Type === _unref(MEDIA_TYPE).Video)
                              ? (_openBlock(), _createElementBlock("video", {
                                  key: 1,
                                  controls: "",
                                  controlsList: "nodownload",
                                  autoplay: _unref(isDeskAutoplay)
                                }, [
                                  _createElementVNode("source", {
                                    src: imag.Url,
                                    type: "video/mp4"
                                  }, null, 8, _hoisted_37)
                                ], 8, _hoisted_36))
                              : _createCommentVNode("", true),
                            (imag.Type === _unref(MEDIA_TYPE).Audio)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                  _createElementVNode("img", {
                                    class: "img-fluid",
                                    src: 
                        __props.selectedStory.DesktopPreview?.Url
                          ? __props.selectedStory.DesktopPreview.Url
                          : ''
                      
                                  }, null, 8, _hoisted_39),
                                  (imag?.Url)
                                    ? (_openBlock(), _createElementBlock("audio", {
                                        key: 0,
                                        class: "audio-container",
                                        controls: "",
                                        controlsList: "nodownload",
                                        autoplay: _unref(isDeskAutoplay),
                                        style: {"width":"100%"}
                                      }, [
                                        _createElementVNode("source", {
                                          src: imag.Url,
                                          type: "audio/mp3"
                                        }, null, 8, _hoisted_41)
                                      ], 8, _hoisted_40))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 8, _hoisted_33))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  (__props.selectedStory.AuthorLogo || __props.selectedStory.AuthorName)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_44, [
                        _createElementVNode("li", _hoisted_45, [
                          _createElementVNode("img", {
                            class: "img-fluid",
                            src: 
                      __props.selectedStory.AuthorLogo.Url
                        ? __props.selectedStory.AuthorLogo.Url
                        : '/images/ico-user.svg'
                    ,
                            alt: 
                      __props.selectedStory.AuthorLogo.Alt ? __props.selectedStory.AuthorLogo.Alt : ''
                    
                          }, null, 8, _hoisted_46),
                          (__props.selectedStory.AuthorName)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(__props.selectedStory.AuthorName), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.selectedStory.CreditName)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _createElementVNode("p", null, _toDisplayString(__props.selectedStory.CreditName), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (__props.selectedStory.Tags)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createElementVNode("ul", _hoisted_50, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectedStory.Tags, (tag, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "list-tag-item",
                            key: index
                          }, [
                            _createElementVNode("button", {
                              class: "btn tag tag-transparent",
                              onClick: (event) => onTagsItemClick(event, tag),
                              type: "button"
                            }, _toDisplayString(tag), 9, _hoisted_51)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}
}

})